import { API_POST_PAY_NOW } from 'src/api/e2e-request-objects';
import { apiRequest } from 'src/api/request-handler';
import { useParams } from 'react-router-dom';

export type PaymentType = 'split' | 'oneTime';

interface PayNowParams {
    aaso_id: string;
    sent_form_id: string;
    store_uuid: string;
    body?: any;
  }
  
  function buildUrlFromTemplate(template: string, params: Record<string, string>) {
    return template.replace(/:([a-zA-Z_]+)/g, (_, key) => {
      if (params[key] === undefined) {
        throw new Error(`Missing URL param: ${key}`);
      }
      return params[key];
    });
  }
  
  export async function handlePaymentOption({ aaso_id, sent_form_id, store_uuid, body }: PayNowParams) {
    const url = buildUrlFromTemplate(API_POST_PAY_NOW.url, {
      aaso_id,
      sent_form_id,
      store_uuid,
    });
    console.log('url', url);
    return apiRequest({ ...API_POST_PAY_NOW, url }, body ? { body } : undefined);
  }

